import React from "react";
import CryptoJS from "crypto-js";
import { Link, Tooltip } from "@mui/material";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const shortenString = (text, max, url = false) => {
  if (text && text.length > max) {
    const shortened = `${text.slice(0, max)}...`;
    return (
      <Tooltip title={text} arrow>
        {url ? (
          <Link href={text} target="_blank" rel="noopener noreferrer">
            {shortened}
          </Link>
        ) : (
          <span>{shortened}</span>
        )}
      </Tooltip>
    );
  }
  return text;
};

export const setEncryptedSessionItem = (key, value) => {
  const encryptedValue = CryptoJS.AES.encrypt(
    JSON.stringify(value),
    SECRET_KEY
  ).toString();
  sessionStorage.setItem(key, encryptedValue);
};

export const getDecryptedSessionItem = (key) => {
  const encryptedValue = sessionStorage.getItem(key);
  if (!encryptedValue) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
